import { api } from "../../api";

const GatewayFileActions = {
    async shareGatewayFile({ state, commit }) {
        const customer = state.activeCustomer;
        const file = state.activeCustomerGateway;
        try {
            await api.gatewaysFiles.share(customer.id, file.id, file.sharedWithIds);
            commit('onSuccess')
        } catch (err) {
            commit('onFailure');
        }
    },
    async saveGatewayFile({ state, commit }) {
        try {
            const customer = state.activeCustomer;
            const file = state.activeCustomerGateway;
            const isUpdate = !!file.id;

            const dto = {
                gateway_id: file.gateway.id,
                encoding_id: (file.encodingId === -1) ? null : file.encodingId,
                comment: (file.comment) ? file.comment : null,
                max_media_download_count: (
                    Number.isInteger(parseFloat(file.maxMediaDownloadCount))
                        ? parseFloat(file.maxMediaDownloadCount)
                        : null
                ),
                download_batch_length: parseInt(file.downloadBatchLength),
                name: file.name,
                metadata_values: file.metadataValues.map(mv => {
                    const metadata = state.activeCustomerGateway.gateway.metadatas.find(m => m.id === mv.id);
                    const value = (metadata.code === '{{ZIP_NAME}}')
                        ? (mv.value && mv.value.endsWith('.zip')) ? mv.value : `${mv.value}.zip`
                        : mv.value;

                    return {
                        metadata_id: mv.id,
                        value,
                    }
                }),
            };

            try {
                isUpdate 
                    ? await api.gatewaysFiles.update(customer.id, file.id, dto) 
                    : await api.gatewaysFiles.create(customer.id, dto);
                return true;
            } catch (err) {
                return false;
            }
        } catch (error) {
            console.log(error);
            commit('onFailure');
        }
    },
    async removeGatewayFile({ commit }, { customerId, gatewayFileId }) {
        try {
            await api.gatewaysFiles.remove(customerId, gatewayFileId);
            return true;
        } catch (error) {
            console.log(error);
            commit('onFailure');
            return false;
        }
    },
}

export default GatewayFileActions;
